import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectYourState: {
    defaultMessage: "Select your branch's state",
    id: 'ChooseProvider.selectYourState',
  },
  providerPerState: {
    defaultMessage: '{groupDisplayName} by state',
    id: 'ChooseProvider.providerPerState',
  },
});
